import { getTagsArray, hasField, hasAnyOfFields, filterTagsBy, isEmpty } from "./useSubscriptions.helpers";

export function getTagsAndConditions(publication) {
  const {
    analysts,
    txCategories,
    txSubCategories,
    gicsIndustryGroups,
    reportTypes,
    companies,
    primaryPeriodicals,
    reportTitles,
    regions,
    currencies,
    themes,
    tradeIdeas
  } = publication || {};

  // Tags
  const subCategoriesTags = getTagsArray({ txSubCategories });
  const gicsIndustryGroupsTags = getTagsArray({ gicsIndustryGroups });
  const primaryPeriodicalsTags = getTagsArray({ primaryPeriodicals });
  const reportTitlesTags = getTagsArray({ reportTitles });
  const analystsTags = getTagsArray({ analysts });
  const companiesTags = getTagsArray({ companies });
  const companiesTagsPD = filterTagsBy(companiesTags, "securityType", "PD");
  const txCategoriesTags = getTagsArray({ txCategories });
  const regionsTags = getTagsArray({ regions });
  const currenciesTags = getTagsArray({ currencies });
  const themesTags = getTagsArray({ themes });
  const tradeIdeasTags = getTagsArray({ tradeIdeas });

  // Conditions
  const isSubCategoriesEmpty = isEmpty(txSubCategories);
  const isTxCategoriesEmpty = isEmpty(txCategories);
  const isCompaniesEmpty = isEmpty(companies);
  const isAnalystsEmpty = isEmpty(analystsTags);
  const isEquityCategory = hasField(txCategories, "Equity");
  const isCompanyQuickNoteReportType = hasField(reportTypes, "Company Quick Note");
  const isFlashSubCategory = hasField(txSubCategories, "Flash");
  const isSectorUpdateSubCategory = hasField(txSubCategories, "Sector Update");
  const isCompanyUpdateSubCategory = hasField(txSubCategories, "Company Update");
  const isModelsSubCategory = hasField(txSubCategories, "Models");
  const isAnchorOrSpecialReportSubCategory = hasAnyOfFields(txSubCategories, ["Anchor Report", "Special Report"]);
  const isWebcastPrimaryPeriodical = primaryPeriodicals?.some((pp) => pp.en === "Webcast");
  const isSpecialTag = isAnchorOrSpecialReportSubCategory || isWebcastPrimaryPeriodical;
  const isFiCategory = hasAnyOfFields(txCategories, [
    "Fixed Income",
    "Economics",
    "FX",
    "Rates",
    "SP__Credit",
    "Macro Strategy",
    "Quants"
  ]);
  const hasPrimaryPeriodicals = primaryPeriodicalsTags.length;

  // For Model research, show all company securities regardless of PD/MM
  const companiesTagsForSection = isModelsSubCategory ? companiesTags : companiesTagsPD;

  // Tag Sections
  const assetClassTags = {
    ...(isSpecialTag && { "Asset Classes": txCategoriesTags })
  };
  const categoriesTags = {
    ...(isSpecialTag && { Categories: subCategoriesTags })
  };
  const tagSections = {
    ...categoriesTags,
    ...assetClassTags,
    Companies: companiesTagsForSection,
    Periodicals: primaryPeriodicalsTags,
    Analysts: analystsTags,
    Sectors: gicsIndustryGroupsTags,
    Currencies: currenciesTags,
    Themes: themesTags,
    "Trade Idea": tradeIdeasTags,
  };
  const multipleCategoriesTagSections = {
    "Asset Classes": txCategoriesTags,
    Analysts: analystsTags,
    Periodicals: primaryPeriodicalsTags,
    Currencies: currenciesTags,
    Themes: themesTags,
    "Trade Idea": tradeIdeasTags,
  };

  // Complex Conditions
  const isCompanyQuickNote = isCompanyQuickNoteReportType && isFlashSubCategory && !isSectorUpdateSubCategory;
  const isMultipleCategories = txCategories?.length > 1;

  return {
    tags: {
      regionsTags,
      reportTitlesTags,
      tagSections,
      multipleCategoriesTagSections
    },
    conditions: {
      isTxCategoriesEmpty,
      isCompaniesEmpty,
      isAnalystsEmpty,
      isEquityCategory,
      isMultipleCategories,
      isFiCategory,
      isSectorUpdateSubCategory,
      isCompanyUpdateSubCategory,
      isModelsSubCategory,
      hasPrimaryPeriodicals,
      isCompanyQuickNote
    }
  };
}
